<div class="user-record">
  <h3>Edit {{ userType }} Record</h3>
  <div class="user-record__container">
    <div class="user-record__grid grid">
      <lib-user-info-panel
        class="user-record__info-panel"
        [enableEdit]="true"
        [isEditing]="true"
        [subServices]="subServices"
        [userData]="userData"
        [userType]="userType"
        (cancelled)="onCancel()"
        (save)="onSave($event)">
      </lib-user-info-panel>
    </div>
  </div>
</div>
